import React from 'react';
import styled from 'styled-components';
import { FormControl } from '../../../../shared/components';

export const FlexFormControl = styled(({ flex, grow, ...restProps }) => (
  <FormControl {...restProps} />
))`
  display: ${({ flex }) => (flex ? 'flex' : 'block')};
  flex-grow: ${({ grow }) => grow};
  width: ${({ flex }) => (flex ? 'auto' : '100%')};
  margin-right: 0.8rem;
  flex: 1;

  &:last-child {
    margin-right: 0;
  }

  .MuiTextField-root {
    width: 100%;
  }
`;

export const FlexFormGroup = styled.div`
  display: flex;
`;

export const ExerciseFormTitle = styled.h3``;
